import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { TarifaService } from 'src/app/services/convenio/tarifa.service';
import { AppState } from 'src/app/state/app.state';
import { selectUser } from 'src/app/state/selectors/user.selectors';

@Component({
  selector: 'app-tarifa',
  templateUrl: './tarifa.component.html',
  styleUrls: ['./tarifa.component.scss']
})
export class TarifaComponent implements OnInit {

  isTarifasPorCarril:any;
  dataTarifas: any;
  dataFormTarifas = [];
  user: any;
  validator = false
  nombre: string;
  public temp: any
  public rowsT: any
  dataCatTarifas: any
  confirmModal = false
  changTarifa: any
  aplicarTarifasPorCarril: boolean = false

  jsonChangTarifa: any;
  jsonTarifasPorCarril: any;
  catCarriles:any
  constructor(
    private ngxUiLoaderService: NgxUiLoaderService,
    private store: Store<AppState>,
    private toastr: ToastrService,
    private tarifaService: TarifaService
  ) {

  }

  ngOnInit(): void {

    this.store.select(selectUser).subscribe(user => this.user = user);
    let variablesG: any[] = JSON.parse(localStorage.getItem('variablesGlobales') + "");
    //si se requiere validacion de JT y si es VSC mandar directo a JT sin importar la cantidad de caravanas
    this.aplicarTarifasPorCarril = variablesG.find(variable => variable.id == 6).valor == "1";
    if(this.aplicarTarifasPorCarril){

      this.tarifaService.getTarifasResource().subscribe(data => {
        this.dataTarifas = data;
      })
    }
    this.getData();
  }

  getData() {
    this.ngxUiLoaderService.start()
    this.tarifaService.getCatTarifas().
      subscribe(data => {
        this.dataCatTarifas = data;
        this.temp = [...this.dataCatTarifas];
        this.rowsT = [...this.dataCatTarifas];
        this.dataCatTarifas = data;
      })
    this.tarifaService.getCarriles().subscribe((carriles: any) => {this.catCarriles = carriles; })
    this.ngxUiLoaderService.stop()
  }

  saveTarifas() {
    let data = {
      tarifas: this.dataFormTarifas,
      id_usuario: this.user.id,
      nombre: this.nombre
    }
    console.log(data);
    this.ngxUiLoaderService.start();
    //api
    this.tarifaService.saveTarifa(data)
      .subscribe(tarifa => {
        this.finished('Tarifas')
        this.getData();

        this.ngxUiLoaderService.stop();
      }), error => {
        this.toastr.error(`Ocurrio un problema`, error, { positionClass: 'toast-bottom-right' });
      }
    this.ngxUiLoaderService.stop();


    var nombreTarifa = document.getElementsByClassName("tarifaNombre");
    const nombre = nombreTarifa[0]as HTMLInputElement;
    nombre.value = "";
    var inputTarifas = document.getElementsByClassName("tarifasEntries");
    for(let tar = 0 ;tar < inputTarifas.length; tar++){
      const element = inputTarifas[tar]as  HTMLInputElement;
          element.value="0";
    }
  }

  finished(type: string) {
    //setear variables
    this.dataFormTarifas = []
    this.nombre = null;
    this.validator = false;
    this.dataFormTarifas = []
    this.toastr.success(`${type} guardado con éxito`, '', { positionClass: 'toast-bottom-right' });

    //this.router.navigate(['/dashboard/convenio']);
  }

  incrementarTarifas(tarifa, event) {

    let index = this.dataFormTarifas.findIndex(m => m.id_clasificacion === tarifa.id);
    index === -1 ? this.dataFormTarifas.push({
      id_clasificacion: tarifa.id,
      tarifa: event.target.value,
    }) : this.dataFormTarifas[index].tarifa = event.target.value;

    console.log(this.dataFormTarifas);
    this.validateTarifas()
  }

  //validar que no se encuentre un 0 en tarifas
  validateTarifas() {
    let index = this.dataFormTarifas.filter((obj) => obj.tarifa == 0);
    if (index.length == 0 && this.dataFormTarifas.length == 15 && this.nombre) {
      this.validator = true
    } else {
      this.validator = false

    }
  }
  getNombreTarifa(event) {
    this.nombre = event.target.value
  }

  changeStatusTarifa() {
    this.ngxUiLoaderService.start();
    let data = {
      idUsuario: this.user.id,
      idCaseta: this.user.caseta_usuario[0].id,
      idTarifa: this.changTarifa.id,
    }
    this.tarifaService.updateActiveTarifas(data)
      .subscribe(tarifa => {
        this.toastr.success(`Tarifa`, 'Se ha modificado con éxito la tarifa', { positionClass: 'toast-bottom-right' });
        this.getData()
        this.confirmModal = false;

        this.ngxUiLoaderService.stop();

      })

  }
  obtenerNombresCarriles(carriles: string[]): string {
    return this.catCarriles
      ?.filter(c => carriles.includes(c.id.toString()))
      .map(c => c.nombre)
      .join(', ') || '';
  }

  openModalConfirm(tarifa:any) {
    this.confirmModal = true;
    this.changTarifa = tarifa;
    this.jsonTarifasPorCarril = JSON.parse(tarifa?.jsonTarifas);
    this.isTarifasPorCarril=(this.jsonTarifasPorCarril[0].tarifas)?true:false
    let jason = JSON.parse(this.changTarifa.jsonTarifas);
    this.jsonChangTarifa = this.extraerNombreClasificacion(this.dataTarifas, jason);

  }


  extraerNombreClasificacion(datosTarifas, montos) {
    var arrayTarifas: Array<{ clasificacion: string, monto: number }> = [
    ];
    datosTarifas.forEach((element:any) => {
      arrayTarifas.push({
        clasificacion: element.vehiculo.tipo,
        monto: montos[element.vehiculo.id]
      })
    });
    return arrayTarifas;
  }
}
